import { Suspense } from 'react';
import './App.css';
import LaunchingSoon from './components/LaunchingSoon';
import PatentContextProvider from './context/PatentContextProvider';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Pillar from './components/FivePillars';

function App() {
  return (
    <div>
      <PatentContextProvider>
        <Router>
          <Routes>
          <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>Ask Jeeves AI</title>
                    <meta
                      name="description"
                      content="Ask Jeeves AI is the modern evolution of the iconic 1996 search engine, now powered by artificial intelligence for smarter search and digital concierge assistance."
                    />
                  </Helmet>

                  <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}>
                    <LaunchingSoon />
                  </Suspense>
                </>
              }
            />
            <Route path='/seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />
          </Routes>
        </Router>
      </PatentContextProvider>
    </div>
  );
}

export default App;
